import Button from '@legacy/common/_components/Button'
import styled from 'styled-components'

export const StyledSaveButton = styled(Button)`
  margin: 1rem 0;
`